import React from 'react';

export const SkeletonDashboardCardsDividendsDivider: React.FC = () => (
    <div className="my-vsmall h-0 w-[5rem] border-b border-b-[rgba(142,145,175,0.24)] md:my-0 md:h-[5rem] md:w-0 md:border-b-0 md:border-l md:border-l-[rgba(142,145,175,0.24)]" />
);
